import type { FaireBrandEntity } from "../../entity_types/brand";

// Anonymized stand-in for the P8 "new & returning" archetype (real metrics, fake identity).
export const bAdvP8NewReturning: FaireBrandEntity = {
  token: "b_adv_p8_new_returning",
  type: "brand",
  name: "Marigold & Main",
  description: "Home decor, seasonal gifts, and everyday keepsakes",
  location: "Columbus, OH",
  rating: 4.9,
  minimumOrderDollars: 200,
  tags: ["home-decor", "gifts", "seasonal"],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
